import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ppt-record-floor-plan',
  templateUrl: './record-floor-plan.component.html',
  styleUrl: './record-floor-plan.component.scss',
})
export class RecordFloorPlanComponent {}
